import { BadgeMap } from 'components/ComposableTable/generators/TextBadgeCell';

export const statusToTextBadge: BadgeMap = {
  valid: {
    color: 'polar-bear',
    textColor: 'pitch',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
  not_uploaded: {
    color: 'polar-bear',
    textColor: 'pitch',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
  incorrect_headers: {
    color: 'lava',
    textColor: 'white',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
  invalid_rows: {
    color: 'lava',
    textColor: 'white',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
  missing: {
    color: 'lava',
    textColor: 'white',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
  unreadable: {
    color: 'lava',
    textColor: 'white',
    textWeight: 'semibold',
    textSize: 'xsmall',
  },
};
